module.exports = __webpack_public_path__ + "img/add-debit-card.87820db2.png";